module.exports = __webpack_public_path__ + "img/li.555a5e93.svg";